import React from "react";
import connect from "Shared/connect";
import * as styles from "./base.scss";
import getMenuIcon from "../../../Category/Commerce/Components/action-creators";
import Icon from "../../../MyMenigo/Shared/MyMenigoIcon/MyMenigoIcon";
import { pushState } from "Shared/history";
const SubCategory = (prop) => (React.createElement("a", { key: prop.category.url, className: styles.link, onClick: () => pushState(prop.category.url), tabIndex: prop.tabIndex },
    React.createElement(Icon, { name: getMenuIcon(prop.category, prop.categoryIcons), className: styles.icon }),
    React.createElement("span", { className: styles.text }, prop.category.displayName)));
export default connect((state) => ({
    categoryIcons: state.appShellData.categoryIcons,
}))(SubCategory);
